// UX: Leere Spalten ausblenden, bis Daten vorhanden sind (z. B. Social "Content").
export function columnHasData(rows, key) {
  return (rows || []).some((row) => {
    const value = typeof key === 'function' ? key(row) : row?.[key];
    return value !== null && value !== undefined && value !== '';
  });
}
